module.exports = __webpack_public_path__ + "assets/grotesk-webfont-f318bac768a4967a15e6fdbcc64c7be3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/font/grotesk-webfont.svg
// module id = 677
// module chunks = 1